import queryString from 'query-string';
import React, {Component} from 'react';

export function getFormattedDate(date) {
    if (!date) {
        return null;
    }
    const formattedDate = date.split('-');
    formattedDate.push(formattedDate.shift());
    return formattedDate.join('/');
}

export function getListingUrl(detailPageUrl, startDate, endDate) {
    if (!detailPageUrl) {
        return '';
    }

    const isDated = !!(startDate && endDate);
    const arrival = getFormattedDate(startDate);
    const departure = getFormattedDate(endDate);
    const urlParts = (detailPageUrl || '').split('?');
    const rawURL = urlParts[0];
    const rawParams = urlParts[1] || '';
    let searchParams = queryString.parse(rawParams);

    if (isDated) {
        searchParams.arrivalDate = arrival;
        searchParams.departureDate = departure;
    } else {
        searchParams.noDates = true;
    }

    return `${rawURL}?${queryString.stringify(searchParams)}`;
}

export class ListingUrl extends Component {
    static defaultProps = {
        onClick: () => {}
    }

    constructor(props) {
        super(props);
        this.linkRef = React.createRef();
    }

    componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.linkRef.current) {
            this.linkRef.current.addEventListener('click', this.onClick);
        }
    }

    componentWillUnmount() {
        // istanbul ignore next
        if (this.linkRef.current) {
            this.linkRef.current.removeEventListener('click', this.onClick);
        }
    }

    onClick = () => {
        // istanbul ignore next
        this.props.onClick();
    }

    render() {
        const {
            children,
            className,
            detailPageUrl,
            onClick, // eslint-disable-line no-unused-vars
            stay,
            ...rest
        } = this.props;
        const {dateRange} = stay || {};
        const {arrival, departure} = dateRange || {};
        const url = getListingUrl(detailPageUrl, arrival, departure);
        const classNames = `listing-url ${className || ''}`;
        return (
            <a
                className={classNames}
                href={url}
                ref={this.linkRef}
                {...rest}
            >
                {children}
            </a>
        );
    }
}

export default ListingUrl;


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-url.js